import * as PIXI from 'pixi.js';
import {pixiComponents} from "../index";
import {CANVAS, REEL, SLOT_BOARD} from "../constants/configs";
import {isMobile, Texture} from "pixi.js";
import {gsap} from "gsap";
import {SlotBoard} from "./slotBoard";
import {universalClick} from "../utilites";
import {setComingSpinQuickFall} from "./spin";


export const addSlotBoard = () => {
    pixiComponents.slotBoard = new SlotBoard({...SLOT_BOARD, reelConfigs: REEL});
    pixiComponents.app.stage.addChild(pixiComponents.slotBoard.container);
    pixiComponents.app.stage.addChild(pixiComponents.slotBoard.multipliersBoard?.totalMultiplayerComponent.container);
}

export const addCanvasBackground = () => {
    const background = PIXI.Sprite.from(isMobile.phone ? './assets/mobile-bg.webp' : './assets/bg.webp');
    background.height = CANVAS.height;
    background.width = CANVAS.width;
    background.anchor.set(0.5)
    background.position.x = CANVAS.width / 2;
    background.position.y = CANVAS.height / 2;
    pixiComponents.app.stage.addChild(background);
    pixiComponents.background = background;
    background.eventMode = "static";
    universalClick(background, setComingSpinQuickFall);

    const bonusBackground = PIXI.Sprite.from(isMobile.phone ? './assets/bonusMobileBg.webp' : './assets/bonusBg.webp');
    bonusBackground.height = CANVAS.height;
    bonusBackground.width = CANVAS.width;
    bonusBackground.anchor.set(0.5)
    bonusBackground.position.x = CANVAS.width / 2;
    bonusBackground.position.y = CANVAS.height / 2;
    bonusBackground.alpha = 0;
    pixiComponents.app.stage.addChild(bonusBackground);
    pixiComponents.bonusBackground = bonusBackground;
}

export const showBonusBackground = () => {
    gsap.to(pixiComponents.bonusBackground, {
        alpha: 1,
        duration: 1.5,
    });
};

export const hideBonusBackground = () => {
    gsap.to(pixiComponents.bonusBackground, {
        alpha: 0,
        duration: 1.5,
    });
}

export const addGameLogo = () => {
    const logo = PIXI.Sprite.from('./assets/logo1.webp');
    logo.anchor.set(0.5, 0.5)
    logo.position.x = 1287;
    logo.position.y = 145;
    logo.rotation = Math.PI / 11;
    logo.width = 255;
    logo.height = 105;
    pixiComponents.app.stage.addChild(logo);
    pixiComponents.logo = logo;

    const logo2 = PIXI.Sprite.from('./assets/logo2.webp');
    logo2.anchor.set(0.5, 0);
    logo2.texture = Texture.from('./assets/logo2.webp');
    logo2.position.x = 280;
    logo2.position.y = 8;
    logo2.rotation = 0;
    logo2.width = 545;
    logo2.height = 41;
    logo2.visible = false;

    pixiComponents.app.stage.addChild(logo2);
    pixiComponents.logo2 = logo2;
}